const quiz = {
  sampleBotContent: {
    schemaVersion: 1,
    templateType: "quiz",
    items: [
      { id: "q1", question: "Quel jour précède le mardi? ", answers: ["lundi"], image: null },
      { id: "q2", question: "Quel jour vient avant vendredi? ", answers: ["jeudi"], image: null },
      { id: "q3", question: "Quel jour vient après mercredi? ", answers: ["jeudi"], image: null },
      { id: "q4", question: "Quel jour vient avant samedi? ", answers: ["vendredi"], image: null },
      { id: "q5", question: "Quel jour vient après samedi? ", answers: ["dimanche"], image: null },
      { id: "q6", question: "Quel jour vient avant dimanche? ", answers: ["samedi"], image: null },
      { id: "q7", question: "Quel jour vient après dimanche? ", answers: ["lundi"], image: null },
      { id: "q8", question: "Quel jour vient avant lundi? ", answers: ["mardi"], image: null },
      { id: "q9", question: "Quel jour vient après vendredi? ", answers: ["samedi"], image: null },
      { id: "q10", question: "Quel jour vient avant vendredi? ", answers: ["jeudi"], image: null },
    ],
  },
  botId: "nualang.quiz.0.0.1",
  botName: "quiz",
  description: "quiz_desc",
  difficulty: "ALL",
  learnLang: "french",
  name: "Lea",
  botAvatar:
    "https://images.nualang.com/eyJidWNrZXQiOiJudWFsYW5nLWltYWdlcy1wcm9kIiwia2V5IjoiYXZhdGFycy8wLW51YWxhLTAwMi5wbmcifQ==",
  picture: `${process.env.REACT_APP_API}/image-creator/848/480/691f89/ffffff/fa-question-circle?fontSize=200`,
  creatorInstructions: "",
  studentInstructions: `# Bienvenue dans le quiz
Animé par Celine.

Connaissez-vous les jours de la semaine ?

Dites "Bonjour" à Celine pour commencer.`,
  voice: "Lea",
  versionQuestion: "Combien de questions souhaitez-vous dans ce modèle?",
};

export default quiz;
